<template>
  <div id="loadOver" style="position: fixed;left: 0;right: 0;bottom: 0;top:0;background-color: #000;z-index: 1000;opacity: 0.5;"></div>
  
  <SeatModal></SeatModal>
  <div v-if="seatpage">
    <!-- <div v-if="showAlert == false"> -->

    <NavBar :currentshow="currentShow"></NavBar>
    <main>
      <section class="content-section" data-background="#ffffff"
        style="background: rgb(255, 255, 255) none repeat scroll 0% 0%;padding-top: 10px; padding-bottom: 0px;">
        <div class="container">
          <div class="row">
            <ShowTime :showTime="currentShowtime"></ShowTime>
            <SeatLayout :showId="$route.params.showid" ref="layoutComp" @seatclicked="showSeats"></SeatLayout>
          </div>
        </div>
      </section>
      <SelectedSeat :selected="selSeats" @seatblocked="seatblocked" @seatbooked="bookedseat"></SelectedSeat>
      <button id="SeatModall" data-toggle='modal'
                data-target="#SeatModal" style="display: none;">
               </button>
    </main>
    <div class="modal" id="smallmodal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body logpop">
            <div class="row pad50">
              Specified show tickets not available online.Please visit the box office!!

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="uniqueId" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true" @click="offline=false;this.$router.push('/index');closenetModal();">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body logpop">
            <div class="row pad50">
              There is some network issue at this cinema. Please try after some time

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!seatpage">
    <MovieFood :seatdetails="blockedseatdetail"></MovieFood>
  </div>
</template>

<script>
import NavBar from './NavBar.vue';
import ShowTime from './ShowTime.vue';
import SeatLayout from './SeatLayout.vue';
import SelectedSeat from './SelectedSeat.vue';
import MovieFood from '../MovieFood/MovieFood.vue';
import axios from 'axios';
import SeatModal from '@/components/UI/SeatModal.vue';
import { URL } from '@/conf.js';
import { Modal } from 'bootstrap';


export default {

  components: {
    NavBar,
    ShowTime,
    SeatLayout,
    SelectedSeat,
    MovieFood,
    SeatModal
  },
  data: () => ({
    offline: false,
    exist: false,
    seatLoaded: false,
    showId: null,
    layoutLoading: true,
    showTimeLoader: true,
    priceDetails: false,
    currentShow: {},
    showAlert: true,
    Languages: { "1": "Malayalam", '2': "Tamil", '3': "Hindi", '4': "English", '5': "Telugu", '6': "Kannada" },
    days: { "0": "Sun", "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat" },
    months: { "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun", "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec" },
    showDates: [],
    showTimes: [],
    bookedSeats: {},
    currentShowtime: [],
    datePages: {},
    selSeats: [],
    blockedseatdetail: {},
    seatpage: true,
    terms: null,
    uniqueModal:null
  }),
  methods: {

    getTerms() {

      axios.get(URL + "Termsandcondition").then((response) => {
        this.terms = response.data.content;
        document.getElementById('SeatModall').click();
      });
    },
    closeModal(type){
      // var modalId=document.getElementById('largeModal');
      // modalId.style.display = "none";
      if(type=="Accept"){
        //
      }
      if(type=="cancel"){
       this.$router.replace({ path: '/' })
      }
      // console.log(modalId);
    },
    showUniqueModal() {
      this.uniqueModal = new Modal(document.getElementById("uniqueId"),{ keyboard: false });
      this.uniqueModal.show();
      },
      closenetModal(){
        this.uniqueModal = new Modal(document.getElementById("uniqueId"),{ keyboard: false });
this.uniqueModal.hide();
      },

    getCurrentShow() {
      this.selSeats = [];
      this.showId = this.$route.params.showid;
      axios.get(URL + "showDetail/" + this.$route.params.showid).then((response) => {
        this.currentShow = response.data.result;
      }).then(() => {
        axios.get(URL + "otherShows/" + this.$route.params.showid).then((response) => {
          this.showTimes = response.data.result.showtime;
          this.bookedSeats = response.data.result.booked;
          this.showDates = Object.keys(this.showTimes);
          this.datePages = [];
          this.lastPage = this.showDates.length;
          for (var i = 0; i < this.lastPage; i++) {
            var splited = this.showDates[i].split("-");
            var pg = { "day": this.days[splited[3]] + " " + splited[2], "mth": this.months[splited[1]] }
            this.datePages.push(pg);
          }
          this.currentShowtime = this.showTimes[this.showDates[0]];
          if (this.showTimes && this.bookedSeats) {
            for (let stime of this.currentShowtime) {
              stime["booked"] = this.bookedSeats[stime.id];
            }
          }
          this.showTimeLoader = false;
        })
      })
    },
    showSeats(selected) {
      this.selSeats = selected;
    },
    seatblocked() {

    },
    bookedseat(bookedseats) {
      this.blockedseatdetail = bookedseats;
      this.seatpage = false;
    }
  },
  created() {

    this.$watch(
      () => this.$route.params,
      () => {
        this.getCurrentShow();
      }
    )
  },
  mounted() {
    this.getCurrentShow();
    this.getTerms();
  },

};
</script>

<style type="text/css" media="screen">
.pagination__item {
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  align-content: center;
  font-size: 1.1rem;
}

.pagination__list {
  list-style-type: none;
}

.pagination__item>button {
  width: 60px;
  height: 45px;
  font-size: 10px;
}

.pagination__item>button,
.pagination__button {
  border: none;
  outline: none;
  stroke: none;
  box-shadow: none;
  cursor: pointer;
  border-radius: 9px;
  background: var(--color-gray);
}

.pagination__list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 350;
  height: 50px;
  border-radius: 9px;
  margin: 0 9px;
  overflow: hidden;
}

.pagination,
.pagination__list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  align-content: center;
}

.pagination__item>button:hover,
.pagination__button:hover {
  background-image: linear-gradient(135deg, rgba(174, 1, 94, 1) 1%, rgba(222, 12, 100, 1) 16%, rgba(235, 18, 89, 1) 30%, rgba(239, 82, 69, 1) 67%, rgba(244, 121, 45, 1) 83%, rgba(254, 187, 23, 1) 100%);
  color: #fff;
}

.pagination__button {
  width: 35px;
  height: 35px;
}

.pagination__item>button,
.pagination__button {
  border: none;
  outline: none;
  stroke: none;
  box-shadow: none;
  cursor: pointer;
  border-radius: 9px;
  background: var(--color-gray);
}

.pagination__item>button,
.pagination__button {
  stroke: none;
  cursor: pointer;
}

.pagination__item>.active {
  background-image: linear-gradient(135deg, rgba(174, 1, 94, 1) 1%, rgba(222, 12, 100, 1) 16%, rgba(235, 18, 89, 1) 30%, rgba(239, 82, 69, 1) 67%, rgba(244, 121, 45, 1) 83%, rgba(254, 187, 23, 1) 100%);
  color: #fff;
}







@import url("https://fonts.googleapis.com/css2?family=Lato&display=swap");

:root {
  --selected-color: #2ecc71;
  --occupied-color: #e74c3c;
  --available-color: #fff;
}

* {
  box-sizing: border-box;
}


.movie-container {
  margin: 20px 0;
}

.movie-container select {
  background-color: #fff;
  border: 0;
  border-radius: 5px;
  font-size: 14px;
  margin-left: 10px;
  padding: 5px 15px 5px 15px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.container {
  perspective: 1000px;
  margin-bottom: 3px;
}

.seat {
  background-color: #444451;
  height: 12px;
  width: 15px;
  margin: 3px;
  float: left;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.seat.selected {
  background-color: #febb17;
}

.seat.occupied {
  background-color: var(--available-color);
}
.launcher {
  height: 25px !important;
}

/* Selects the second row f*/
/*.seat:nth-of-type(2) {
  margin-right: 18px;
}

.seat:nth-last-of-type(2) {
  margin-left: 18px;
}*/

.seat:not(.occupied) {
  cursor: pointer;
  transform: scale(1.2);
}

.showcase .seat:not(.occupied) {
  cursor: default;
  transform: scale(1);
}

.showcase {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 5px 10px;
  border-radius: 5px;
  color: #777;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
}

.showcase li {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
}

.showcase li small {
  margin-left: 2px;
}

.row {
  display: flex;
}

.screen {
  background-color: #aaa;
  height: 70px;
  width: 69%;
  margin: 15px 0;
  transform: rotateX(-145deg);
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
}

p.text {
  margin: 5px 0;
}

p.text span {
  color: #6feaf6;
}


@media only screen and (max-width : 768px) {

  .screen {
    width: 100%;
  }

}



.seat-wrapper .btn-seatbook,
.seat-wrapper .btn-damaged {
  cursor: not-allowed;
  transition: all 300ms ease-in-out;
  background: #e10018;
  color: #fff0;
}

.seat-wrapper .btn-seat {
  transition: all 300ms ease-in-out;
  background-color: #cacaca;
  color: #cacaca;
}

.seat-wrapper button {
  font-size: 8px;
  background-color: #6feaf6;
  height: 16px;
  width: 19px;
  margin: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  fill: #444451;
  border: none;
  padding: 2px 0px 0px 0px;
}




.class-head {
  border-bottom: 1px solid #dddddd87;
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 0 5px 0;
  text-align: center;
  color: #2e2e2e;
}

.seat-wrapper .bt-label {
  color: #2e2e2e;
  background: none !important;
  line-height: 1;
  font-size: 1.1em;
  font-weight: bold;
}
</style>
